export default __webpack_public_path__ + "static/media/mode-2042.028d293b.svg";